module.exports = __webpack_public_path__ + "static/media/modular_logo_small_black.b0113efe.svg";